import { Flex } from 'antd';

const FlexCenter = ({ children, gap = 0, style = {}, align = 'center', justify = 'center', className = '' }) => {
  return (
    <Flex gap={gap} align={align} justify={justify} vertical style={{ flex: 1, ...style }} className={className}>
      {children}
    </Flex>
  );
};

export default FlexCenter;
